var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-80 -70 250 250",
    style: {
      enableBackground: "new 0 0 103 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.6,49.8C37.5,49.8,26,38.7,26,25S37.5,0.1,51.6,0.1c14.1,0,25.6,11.2,25.6,24.9S65.8,49.8,51.6,49.8z M51.6,6.3 C41,6.3,32.4,14.7,32.4,25S41,43.6,51.6,43.6c10.6,0,19.2-8.4,19.2-18.7S62.2,6.3,51.6,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9,100.1H3.3c-1.8,0-3.2-1.4-3.2-3.1c0-19.9,12.1-37.9,30.9-45.8c1.5-0.6,3.2-0.1,4,1.3c3.5,5.7,9.7,9.2,16.5,9.2 s13-3.4,16.5-9.2c0.8-1.4,2.6-1.9,4-1.3c18.8,8,30.9,25.9,30.9,45.8C103.1,98.7,101.7,100.1,99.9,100.1z M6.6,93.9h90 c-1.1-15.3-10.4-29-24.6-35.9c-4.8,6.1-12.4,9.9-20.4,9.9S36,64.1,31.2,57.9C17.1,64.9,7.8,78.6,6.6,93.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlack);
export default __webpack_public_path__ + "static/media/profile-black.9465c142f00e550c76c248a27ce5b20e.svg";
export { ForwardRef as ReactComponent };